/**
 * IMPORTANT
 * This file is exclusively for Vue 3 usage.
 *
 *
 * Vue3 file: js/services/EpsilonTaggingManager/EpsilonTaggingManager.js
 * Vue3 file: Cutrrent FIle
 *
 * If you are making changes  in this file,
 * please make sure to make the same changes in the Vue2 file as well.
 *
 * For further details, please contact Leela.
 *
 */

import { EpsilonVolvoTagging } from './OEMTagManagers/EpsilonVolvoTagging';

export class EpsilonTagManagerContainer {
  constructor() {
    this.make = window.make;
  }

  static getDealerObject() {
    let object = '';
    if (
      window.enableOEMProgram &&
      window.enableWebsiteTagging &&
      window.enableEpsilonTags &&
      window.oemProgramName === 'Volvo'
    ) {
      return new EpsilonVolvoTagging();
    }

    return object;
  }
}
